<template>
  <div class="card">
    <b-modal id="modal_form" ref="modal_form" title="Apontar Ocorrencia" o-close-on-backdrop v-model="showModal"
      size="lg" @ok-disabled=true>
      <div class="loadingData" v-if="loadingData">
        <div class="loadingDataSpinner">
          <spinner text-fg-color="#ffffff" message="Carregando..."></spinner>
        </div>
      </div>

      <b-row no-gutters>
        <b-col md=" 2" :cols="deviceSize == DeviceSizeEnum.XS ? 8 : null" class="fl-flex-label fl-collapsed">
          <b-input v-model="area.input" maxlength="8" autofocus type="text" ref="area" :disabled="area.disabled"
            @keyup.enter="onSetArea()">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.area.focus()">Area</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('area_id')"
            v-if="requestErrors.has('area_id')"></b-form-feedback>
        </b-col>
        <b-col md="1" cols="4" class="fl-flex-label fl-collapsed">
          <b-input v-model="pallet.input" maxlength="8" type="text" ref="pallet" :disabled="pallet.disabled">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.pallet.focus()">Pallet</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('pallet_id')"
            v-if="requestErrors.has('pallet_id')"></b-form-feedback>
        </b-col>
        <b-col md="2" class="fl-flex-label fl-collapsed">
          <multiselect v-model="occurance.input" :options="occurance.options" :disabled="occurance.disabled"
            track-by="parocorren_id" label="descr" :hide-selected="true" placeholder="Ocorrencia" ref="occurance"
            tag-placeholder="Selecionar" select-label="Selecionar" selected-label="Selecionado" deselect-label="Remover"
            @keyup.enter="$refs.barcode.focus()"></multiselect>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('parocorren_id')"
            v-if="requestErrors.has('parocorren_id')"></b-form-feedback>
        </b-col>
        <b-col v-if="barcode.visible" md="2" class="fl-flex-label fl-collapsed">
          <b-input v-model="barcode.input" maxlength="31" type="text" v-on:keyup.enter="onScan()" ref="barcode"
            :disabled="barcode.disabled" @contextmenu="!barcode.canWrite && $event.preventDefault()"
            @dragover="!barcode.canWrite && $event.preventDefault()"
            @paste="!barcode.canWrite && $event.preventDefault()" :autocomplete="barcode.canWrite ? 'on' : 'off'">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.barcode.focus()">Codigo de
            Barras</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('cd_barra')"
            v-if="requestErrors.has('cd_barra')"></b-form-feedback>
          <span>Qtde. caracteres código de barra: {{ barcode.input.length }}</span>
        </b-col>
        <b-col v-if="!barcode.visible" md="1" class="fl-flex-label fl-collapsed">
          <b-input v-model="invoice.fiscalNumberInput" id="invoice" maxlength="20" type="text" ref="fiscalNumber"
            :disabled="invoice.disabled">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.fiscalNumber.focus()">Numero da
            Nota</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('num_fiscal')"
            v-if="requestErrors.has('num_fiscal')">
          </b-form-feedback>
        </b-col>
        <b-col v-if="!barcode.visible" md="1" class="fl-flex-label fl-collapsed">
          <b-input v-model="invoice.seriesInput" maxlength="3" type="text" ref="serie" :disabled="invoice.disabled">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.serie.focus()">Serie</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('serie')" v-if="requestErrors.has('serie')">
          </b-form-feedback>
        </b-col>
        <b-col v-if="!barcode.visible" md="2" class="fl-flex-label fl-collapsed">
          <b-input v-model="invoice.cnpjInput" id="cnpj" maxlength="14" type="text" ref="cnpj"
            :disabled="invoice.disabled">
          </b-input>
          <label class="fl-label" style="left: 13px; right: 12px" @click="$refs.cnpj.focus()">CNPJ Emitente</label>
          <b-form-feedback class="text-danger" v-text="requestErrors.get('emi_cnpj')"
            v-if="requestErrors.has('emi_cnpj')">
          </b-form-feedback>
        </b-col>
        <b-col md="3" cols="12" class="">
          <div class="button-group">
            <b-btn v-if="barcode.visible" @click="onScan()" class="secondary" :disabled="barcode.buttonDisabled"
              :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }">Escanear código</b-btn>
            <b-btn v-if="!barcode.visible" @click="onScanByInvoice()" class="secondary"
              :disabled="invoice.buttonDisabled">Escanear nota</b-btn>
            <b-btn @click="onClear()" :disabled="clearIsDisabled" class="secondary"
              :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }">Limpar</b-btn>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <h6 class="ml-1">
            Qtde. volumes bipados / Total de volumes : {{ this.volumesBiped }}/{{ this.volumesTotal }}
          </h6>
        </b-col>
        <b-col md="4">
          <div>
            <input type="checkbox" v-model="occuranceByInvoice.isChecked" :disabled="occuranceByInvoice.disabled"
              @change="setInputByInvoice"> Apontar ocorrencia por NF
          </div>
        </b-col>
      </b-row>
      <!--Body -->
      <vuetable ref="vuetable" :data="tableData" :api-mode="false" :fields="fields" :css="css"
        :append-params="moreParams" track-by="invoiceId" pagMdfeination-path="" @vuetable:loaded="onLoaded"
        @vuetable:onDetail="onDetail" @vuetable:cell-clicked="onDetail" detail-row-component="volume-details"
        :row-class="rowClass" no-data-template="Começe a bipagem para popular a lista"
        :class="{ 'table-responsive': deviceSize == DeviceSizeEnum.XS }">

        <template slot="area" slot-scope="props">
          <span>
            {{ area.id }}
          </span>
        </template>

        <template slot="actions" slot-scope="props">
          <div class="custom-actions">
            <span>
              <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i
                  class="fa fa-plus"></i></a>
            </span>
          </div>
        </template>
      </vuetable>
      <div slot="modal-footer" class="w-100">
        <div class="float-right">
          <b-btn @click="onCloseModal" variant="secondary">
            Cancelar
          </b-btn>
          <b-btn @click="onFinish" variant="secondary" :disabled="finishIsDisabled">
            Finalizar
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros.vue";
import VuetablePagination from "../components/VuetablePagination.vue";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo.vue";
import VolumeDetails from "../components/VolumeDetails.vue";
import Vuetable from "../components/Vuetable";
import ApontamentoOcorrenciaModal from "./ApontamentoOcorrenciaModal.vue";
import { formatDateTime, rowClassByDueDate } from "../utils";
import Errors from "../Errors";
import { DeviceSizeEnum } from "../enums/GeneralEnums";

Vue.component("volume-details", VolumeDetails);
export default {
  components: {

    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ApontamentoOcorrenciaModal,
  },
  data() {
    return {
      area: {
        disabled: false,
        input: "",
        id: 0,
      },

      pallet: {
        visible: true,
        disabled: true,
        input: '',
      },

      barcode: {
        visible: true,
        disabled: true,
        input: '',
        value: '',
        lastTimeInput: 0,
        canWrite: false,
        buttonDisabled: true,
      },

      occurance: {
        disabled: true,
        input: null,
        options: [],
      },

      occuranceByInvoice: {
        isChecked: false,
        disabled: true,
      },

      invoice: {
        fiscalNumberInput: null,
        seriesInput: null,
        cnpjInput: null,
        disabled: true,
        buttonDisabled: true,
      },

      group: {
        bips: new Map(),
        invoices: new Map(),
      },

      clearIsDisabled: true,
      finishIsDisabled: true,

      showModal: false,
      inputKey: 0,
      errors_array: [],
      notas_fiscais: [],

      volumesBiped: 0,
      volumesTotal: 0,
      volumeBipedQuantity: 0,
      finishedInvoiceQuantity: 0,
      finishedInvoiceweight: 0,

      invoiceDueAlert: false,
      invoiceDueAlertDays: 0,

      song: new Audio(),
      success: require("../../public/audio/sucesso.mp3"),
      error: require("../../public/audio/erro.mp3"),


      requestErrors: new Errors(),
      moreParams: {},
      loadingData: false,

      DeviceSizeEnum,

      tableData: null,
      fields: [
        { name: 'occuranceDescr', title: 'Ocorrencia' },
        { name: "fiscalNumer", title: "Nº Fiscal" },
        { name: "serie", title: "Serie" },
        {
          name: "emissionDate", title: "Data Emissão",
          callback: (value) => { return this.formatDateTime(value); }
        },
        {
          name: "previsionDate", title: "Data Previsão",
          callback: (value) => { return this.formatDateTime(value); }
        },
        { name: "volumeNumber", title: "Volume" },
        { name: "volumeQuantity", title: "Qtde. Volumes" },
        { name: "senderCNPJ", title: "CNPJ Emi" },
        { name: "senderName", title: "Razão Social Emi" },
        { name: "area", title: "Área CD" },
        { name: "pallet", title: "Pallet" },
      ],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
    }
  },
  methods: {
    onCloseModal() {
      this.onClear({ andCloseModal: true });
    },
    onCreate() {
      this.showModal = true;
      this.setStoreData();
      this.setFilters();
    },
    setFilters() {
      new Form({})
        .get('/api/conferencia_volume/bip_ocorrencia_filtros')
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          this.occurance.options = response.ocorrencias;
        })
    },
    formatDateTime(value) {
      return formatDateTime(value);
    },

    onLoaded() {
      this.loadingData = false;
    },
    onDetail(data) {
      this.$refs.vuetable.toggleDetailRow(data.volumeId);
    },
    onClear({ andCloseModal = false, showAlert = true } = {}) {
      const executeClear = () => {
        this.group.invoices = new Map();
        this.group.bips = new Map();
        this.clearIsDisabled = true;
        this.area.input = "";
        this.area.disabled = false;
        this.pallet.input = '';
        this.pallet.disabled = true;
        this.pallet.visible = true;
        this.occurance.input = null;
        this.occurance.disabled = true;
        this.barcode.input = '';
        this.tableData = null;
        this.finishedInvoiceQuantity = 0;
        this.finishedInvoiceweight = 0;
        this.volumeTotal = 0;
        this.volumesBiped = 0;
        this.volumesTotal = 0;
        this.finishIsDisabled = true;
        this.occuranceByInvoice.isChecked = false;
        this.invoice.seriesInput = null;
        this.invoice.fiscalNumberInput = '';
        this.invoice.cnpjInput = '';
        this.barcode.visible = true;

        if (andCloseModal) {
          this.showModal = false;
        }
      }
      if (showAlert) {
        return this.$Simplert.open({
          title: "Atenção",
          message: "Deseja mesmo cancelar o apontamento? Todo seu progresso será perdido",
          customConfirmBtnText: "Sim",
          customCloseBtnText: "Não",
          type: "info",
          useConfirmBtn: true,
          onConfirm: () => {
            executeClear();
          }

        });
      }
      else {
        executeClear();
      }
    },

    rowClass(data) {
      return rowClassByDueDate(
        data.previsionDate,
        this.invoiceDueAlert,
        this.invoiceDueAlertDays);
    },

    onSetArea() {
      if (this.area.input == "") {
        return
      }
      this.loadingData = true;
      const payload = new Form({});

      payload
        .get("/api/area?qrcode=" + this.area.input)
        .then((response) => {
          this.loadingData = false;
          new ReturnApi(response, this);

          if (response.data.length === 0) {
            this.area.input = "";
            return this.$Simplert.open({
              title: "Atenção",
              message: "Área não encontrada!",
              customCloseBtnText: "Fechar",
              type: "warning",
            });
          }

          const area = response.data[0];
          const areaDetails = `A${area.areaId} - ${area.descr}`;
          this.$Simplert.open({
            title: "Confirma seleção de área?",
            message: areaDetails,
            customConfirmBtnText: "Sim",
            customCloseBtnText: "Não",
            type: "info",
            useConfirmBtn: true,
            onConfirm: () => {
              this.area.disabled = true;
              this.area.id = area.areaId;
              this.pallet.disabled = false;
              this.$nextTick(() => {
                this.area.input = areaDetails;
                this.clearIsDisabled = false;
                this.loadingData = false;
                this.$nextTick(() => {
                  this.$refs.pallet.focus();
                });
              });
            },
            onClose: () => {
              this.$Simplert.open({
                title: "Seleção cancelada",
                message: "",
                customCloseBtnText: "Fechar",
                type: "info",
              });
              this.area.input = null;
            },
          });
        })
        .catch((error) => {
          this.loadingData = false;
          return this.$Simplert.open({
            title: "Atenção",
            message: "Erro ao buscar área, contate o suporte!",
            customCloseBtnText: "Fechar",
            type: "error",
          });
        });
    },

    playNotify(musica) {
      this.song.src = musica;
      this.song.play();
    },

    onScan() {
      if (this.group.bips.size > 0 && [...this.group.bips.values()].some(bip => bip.barcode === this.barcode.input)) {
        return this.$Simplert.open({
          title: "Atenção",
          message: "Volume já bipado!",
          customCloseBtnText: "Fechar",
          type: "warning",
        });
      }

      const payload = new Form({
        area_id: this.area.id,
        pallet_id: this.pallet.input,
        parocorren_id: this.occurance.input.parocorren_id,
        cd_barra: this.barcode.input,
        notas_bipadas: this.group.invoices
      });

      this.loadingData = true;
      this.barcode.value = this.barcode.input;
      this.barcode.input = '';

      payload.post('/api/conferencia_volume/bip_ocorrencia')
        .then((response) => {
          this.loadingData = false;
          this.playNotify(this.success);
          this.$snotify.success('Bipagem realizada com sucesso', 'Sucesso');
          this.pushInGroup(response);
        })
        .catch((errors) => {
          this.playNotify(this.error);
          this.loadingData = false;
          this.requestErrors = payload.errors;

          if (errors.mensagem) {
            if (errors.mensagem.includes('Área inválida para o bip')) {
              let message = errors.mensagem + (errors.area_correta ? ` - Direcione para a area A${errors.area_correta.area_id} - ${errors.area_correta.descr}` : '');
              return this.$Simplert.open({
                title: "Atenção",
                message: message,
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }
            if (errors.mensagem.includes('Usuário tentou bipar uma nota cancelada')) {
              return this.$Simplert.open({
                title: "Atenção",
                message: 'Usuário tentou bipar uma nota cancelada',
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }
          }

          if (errors.message.includes("Usuário tentou bipar uma area de recebimento ou triagem")) {
            console.log(errors);
            this.$snotify.error("Usuário tentou bipar uma area de recebimento ou triagem", "Erro");

            return;
          }

          return new ReturnApi(errors, this, true, false, true, false,);
        });

    },

    onScanByInvoice() {
      const payload = new Form({
        num_fiscal: this.invoice.fiscalNumberInput,
        serie: this.invoice.seriesInput,
        emi_cnpj: this.invoice.cnpjInput,
        area_id: this.area.id,
        pallet_id: this.pallet.input,
        parocorren_id: this.occurance.input.parocorren_id,
        ocorrencia_descr: this.occurance.input.descr,
      });
      this.loadingData = true;
      payload
        .post('/api/conferencia_volume/bip_ocorrencia_por_nota')
        .then((response) => {
          this.loadingData = false;
          this.pushInGroup(response);
          this.playNotify(this.success);
          this.$snotify.success('Nota bipada com sucesso', 'Sucesso');
        })
        .catch((errors) => {
          this.playNotify(this.error);
          this.loadingData = false;
          this.requestErrors = payload.errors;
          if (errors.mensagem) {
            if (errors.mensagem.includes('Área inválida para o bip')) {
              let message = errors.mensagem + (errors.area_correta ? ` - Direcione para a area A${errors.area_correta.area_id} - ${errors.area_correta.descr}` : '');
              return this.$Simplert.open({
                title: "Atenção",
                message: message,
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }
            if (errors.mensagem.includes('Usuário tentou bipar uma nota cancelada')) {
              return this.$Simplert.open({
                title: "Atenção",
                message: 'Usuário tentou bipar uma nota cancelada',
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }
          }
          return new ReturnApi(errors, this, true, false, true, false,);
        });
    },

    pushInGroup(response) {
      let volumesToBip = [];

      if (!response.volume_bipado_id) {
        volumesToBip = response.doc_fiscal.doc_fiscal_volume.map(volume => volume.docfisvol_id);
      }
      else {
        volumesToBip = [response.volume_bipado_id];
      }

      for (const v of volumesToBip) {
        const payloadVolume = response.doc_fiscal.doc_fiscal_volume.find(
          volume => volume.docfisvol_id === v
        );

        if (payloadVolume) {
          this.setGroupBip({
            'doc_fiscal': response.doc_fiscal,
            'volume': payloadVolume
          });
        }
      }

      this.finishIsDisabled = false;
      this.tableData = Array.from(this.group.bips.values());
      this.volumesBiped = this.group.bips.size;
      this.volumesTotal = Array.from(this.group.invoices.values())
        .reduce((sum, invoice) => sum + invoice.qtd_volume, '');
      this.finishedInvoiceweight = `${Array.from(this.group.invoices.values())
        .reduce((sum, invoice) => sum + invoice.peso_bruto_total, '')} kg`; //TODO
      this.finishedInvoiceQuantity = 1; //TODO

    },

    setGroupBip(bipInput) {
      this.group.bips.set(
        bipInput.volume.docfisvol_id,
        {
          fiscalNumer: bipInput.doc_fiscal.num_fiscal,
          serie: bipInput.doc_fiscal.serie,
          emissionDate: bipInput.doc_fiscal.dt_emissao,
          previsionDate: bipInput.doc_fiscal.dt_previsao,
          volumeNumber: bipInput.volume.num_volume,
          volumeQuantity: bipInput.doc_fiscal.qtd_volume,
          senderCNPJ: bipInput.doc_fiscal.doc_fiscal_partes_env.emi_cnpj,
          senderName: bipInput.doc_fiscal.doc_fiscal_partes_env.emi_nome,
          area: this.area.id,

          invoiceId: bipInput.doc_fiscal.docfis_id,
          volumeId: bipInput.volume.docfisvol_id,
          occuranceId: this.occurance.input.parocorren_id,
          occuranceDescr: this.occurance.input.descr,
          pallet: this.pallet.input,
          barcode: this.barcode.value,
          dateBip: (new Date()).toISOString(),
        });
      this.group.invoices.set(
        bipInput.doc_fiscal.docfis_id,
        bipInput.doc_fiscal

      );
    },

    setInputByInvoice() {
      const byInvoice = this.occuranceByInvoice.isChecked;
      if (byInvoice) {
        this.barcode.visible = false;
        this.barcode.input = "";
      }
      else {
        this.barcode.visible = true;
        this.invoice.seriesInput = null;
        this.invoice.fiscalNumberInput = null;
        this.invoice.cnpjInput = null;
      }
    },

    checkInvoiceInput() {
      this.invoice.buttonDisabled = !(
        this.invoice.fiscalNumberInput &&
        this.invoice.seriesInput &&
        this.invoice.cnpjInput)
    },

    onFinish() {
      const sendToRoute = () => {
        this.loadingData = true;
        const payload = new Form(this.createFinishJson());

        payload.post(`/api/conferencia_volume/grupo_ocorrencia/finalizar`)
          .then((response) => {
            this.loadingData = false;
            this.$Simplert.open({
              title: "Sucesso",
              message: "Volumes apontados com sucesso.",
              customCloseBtnText: "Fechar",
              type: "success",
              onClose: () => {
                this.onClear({ showAlert: false, andCloseModal: true });
                this.$emit('clearOccurrenceTable');
              }
            })
          })
          .catch((error) => {
            this.loadingData = false;
            this.requestErrors = payload.errors;
            this.$Simplert.open({
              title: "Erro",
              message: "Erro ao apontar volumes.",
              customCloseBtnText: "Fechar",
              type: "error",
            })
          });
      }

      if (this.group.bips.size < this.volumesTotal) {
        if (!this.getPermissionFw('conferencia_volume.finalizar_especial')) { // TODO: Permissões diferentes entre conferencia e apontamento?
          return this.$Simplert.open({
            title: "Atenção",
            message: "Há volumes pendentes nas notas para serem apontados.", // TODO: Mostrar os volumes pendentes
            customCloseBtnText: "Fechar",
            type: "warning",
          })
        }
        return this.$Simplert.open({
          title: "Atenção",
          message: "Há volumes pendentes nas notas para serem apontados.", // TODO: Mostrar os volumes pendentes
          customConfirmBtnText: 'Finalizar Especial',
          customCloseBtnText: "Fechar",
          type: "warning",
          useConfirmBtn: true,
          onConfirm: () => {
            sendToRoute();
          }
        })
      }
      sendToRoute();
    },
    createFinishJson() {
      const groupBeeps = Array.from(this.group.bips.values());
      const invoices = Array.from(this.group.invoices.values());

      const volumes = groupBeeps.reduce((acc, currentVolume) => {
        if (!acc[currentVolume.invoiceId]) {
          acc[currentVolume.invoiceId] = [];
        }

        acc[currentVolume.invoiceId].push({
          docfisvol_id: currentVolume.volumeId,
          pallet_id: currentVolume.pallet,
          parocorren_id: currentVolume.occuranceId,
          ocorrencia_descr: currentVolume.occuranceDescr,
          cd_barra: currentVolume.barcode,
          dt_bip: currentVolume.dateBip
        });

        return acc;
      }, {})

      const notas_bipadas = invoices.map(invoice => {
        const { docfis_id } = invoice;

        return {
          docfis_id,
          volumes: volumes[docfis_id] || []
        };
      });

      return {
        area_id: this.area.id, notas_bipadas
      }
    },

    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    setStoreData() {
      this.barcode.canWrite = this.getPermission("geral.digitarbip");
      this.invoiceDueAlert = this.$store.getters.unidade_active.aviso_vencimento;
      this.invoiceDueAlertDays = this.$store.getters.unidade_active.dias_vencimento;
    }
  },

  watch: {
    tableData(data, oldData) {
      // this is wrong, but it takes two ticks to update the table, should be something within the tableData variable and its reactibility
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$refs.vuetable.refresh();
          this.loadingData = false;
        });
      })
    },

    'barcode.input'(newData, oldData) {
      if (newData == '') return
      const inputTime = new Date().getTime();

      if (oldData.length > 1 &&
        !this.barcode.canWrite &&
        inputTime - this.barcode.lastTimeInput > 100) {
        this.$nextTick(() => {
          this.barcode.input = "";
          return alert("Apenas bipagem é permitida.");
        });
      }
      this.barcode.lastTimeInput = inputTime;
      if (newData.length == 28 || newData.length == 29 || newData.length == 31) {
        this.barcode.buttonDisabled = false;
      } else {
        this.barcode.buttonDisabled = true;
      }
    },

    'pallet.input'(data) {
      const disable = data == ''
      this.occurance.disabled = disable;
      this.invoice.disabled = disable;
      this.occuranceByInvoice.disabled = disable;
    },

    'occurance.input.parocorren_id'(data) {
      this.barcode.disabled = data == null;
    },

    'invoice.fiscalNumberInput'(data) {
      this.checkInvoiceInput();
    },

    'invoice.seriesInput'(data) {
      this.checkInvoiceInput();
    },
    'invoice.cnpjInput'(data) {
      this.checkInvoiceInput();
    },
  },

  computed: {
    deviceSize() {
      return this.$store.getters.device_size
    }
  },
};

</script>
